import { InsightGetters } from "~/@types";
import NavOrExternalLink from "../shared/NavOrExternalLink";
import clsx from "clsx";

type TopicProps = {
  topic: NonNullable<ReturnType<InsightGetters["getTopic"]>>;
  noDot?: boolean;
  className?: string;
  isLink?: boolean;
  padding?: boolean;
};

export default function TopicComponent({
  topic,
  noDot,
  className,
  isLink = true,
  padding = true,
}: TopicProps) {
  if (!isLink) {
    return (
      <div
        data-content-type="topic"
        data-module-title={topic.slug}
        className={clsx("cta uppercase", className, padding && "py-4")}
      >
        {!noDot && (
          <span
            className="mr-2 inline-block h-[10px] w-[10px] rounded-full lg:h-[12px] lg:w-[12px]"
            style={{ backgroundColor: topic.color }}
          />
        )}
        {topic.title}
      </div>
    );
  }
  return (
    <NavOrExternalLink
      data-content-type="topic"
      data-module-title={topic.slug}
      to={`/insights/${topic.slug}`}
      className={`cta py-4 uppercase ${className}`}
      prefetch="intent"
    >
      {!noDot && (
        <span
          className="mr-2 inline-block h-[10px] w-[10px] rounded-full lg:h-[12px] lg:w-[12px]"
          style={{ backgroundColor: topic.color }}
        />
      )}
      {topic.title}
    </NavOrExternalLink>
  );
}
